import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Heart, MapPin } from "lucide-react";
import { supabase } from "@/lib/supabase";
import { useApp, Listing } from "@/contexts/AppContext";
import ListingCard from "@/components/ListingCard";

export default function FavoritesPage() {
  const { user } = useApp();
  const [listings, setListings] = useState<Listing[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    async function fetch() {
      setLoading(true);
      const { data } = await supabase
        .from("favorites")
        .select("listing_id, listings(*)")
        .eq("user_id", user!.id)
        .order("created_at", { ascending: false });

      if (data) {
        setListings(data.map((f: any) => ({
          id: f.listings.id,
          title: f.listings.title,
          category: f.listings.category,
          description: f.listings.description,
          price: f.listings.price,
          priceUnit: f.listings.price_unit,
          city: f.listings.city,
          state: f.listings.state,
          images: f.listings.images || [],
          ownerId: f.listings.owner_id,
          ownerName: f.listings.owner_name,
          phone: f.listings.phone,
          whatsapp: f.listings.whatsapp,
          email: f.listings.email,
          availability: f.listings.availability || [],
          views: f.listings.views || 0,
          rating: f.listings.rating || 0,
          reviewCount: f.listings.review_count || 0,
          contactsRevealed: 0,
          createdAt: f.listings.created_at,
          featured: f.listings.featured,
          status: f.listings.status,
          listingType: f.listings.listing_type,
          latitude: f.listings.latitude,
          longitude: f.listings.longitude,
        })));
      }
      setLoading(false);
    }
    fetch();
  }, [user?.id]);

  if (!user) return <Navigate to="/login" />;

  return (
    <div className="container mx-auto px-4 py-8 max-w-5xl">
      <div className="flex items-center gap-3 mb-6">
        <Heart className="h-6 w-6 text-red-500 fill-current" />
        <h1 className="text-2xl font-heading font-bold">Meus Favoritos</h1>
      </div>

      {loading ? (
        <div className="text-center py-20 text-muted-foreground">Carregando...</div>
      ) : listings.length === 0 ? (
        <div className="text-center py-20 text-muted-foreground">
          <Heart className="h-12 w-12 mx-auto mb-4 opacity-30" />
          <p className="font-medium mb-2">Nenhum favorito ainda</p>
          <p className="text-sm mb-4">Explore os anúncios e salve os que mais gostar.</p>
          <Link to="/busca" className="text-primary hover:underline text-sm font-medium">
            Explorar anúncios →
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {listings.map((l) => <ListingCard key={l.id} listing={l} />)}
        </div>
      )}
    </div>
  );
}
